(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-footer"]) return;
  try {
    
  // The footer is on every page, so this is where the mobile menu learns to close itself
  // when one of its links points to a section of the page that is already open.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('header-drawer a[href*="#"]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (!url.hash || url.pathname !== window.location.pathname) return;
    const drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });

  } catch(e) { console.error(e); }
})();
})();
